import _ from 'lodash'
import {getId, getType} from '../../../apis/model/base'
import {familyBook_getFamilyBookStats_Api} from '../../../apis/familyBook'
import {organization_fetchStatistics_Api} from '../../../apis/organization'
import {bindQueryParams} from '../../AppLocals/functions/routerHelper'
import {createWorkspaceBadge} from './WorkspaceSidebarBadge'

export const PendingHouseholdsBadge = createWorkspaceBadge({
    apiInfo: familyBook_getFamilyBookStats_Api,
    getQuery: (org) => bindQueryParams([{type: getType(org)}, {id: getId(org)}]),
    getCacheId: (org) =>
        [
            familyBook_getFamilyBookStats_Api.path
                .replace(':type', getType(org))
                .replace(':id', getId(org)),
            JSON.stringify({}),
        ].join('/'),
    selectCount: (response) => _.get(response, 'data.total.pending', 0),
})

export const PendingEnrollmentsBadge = createWorkspaceBadge({
    apiInfo: organization_fetchStatistics_Api,
    getQuery: (org) => bindQueryParams([{id: getId(org)}]),
    getCacheId: (org) =>
        [
            organization_fetchStatistics_Api.path.replace(':id', getId(org)),
            JSON.stringify({}),
        ].join('/'),
    selectCount: (response) => _.get(response, 'data.pending_stats.pending_course_registers_count', 0),
})
